import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

type Props = {
    page: number;
    setPage: (p: number | ((prev: number) => number)) => void;
    totalPages: number;
    totalItems: number;
    pageSize: number;
    setPageSize: (size: number) => void;
    loading?: boolean;
};

export default function Pagination({
    page,
    setPage,
    totalPages,
    totalItems,
    pageSize,
    setPageSize,
    loading = false,
}: Props) {

    const getRange = (size: number) => {
        if (totalItems === 0) return "0-0";

        const start = page * size + 1;
        const end = Math.min((page + 1) * size, totalItems);

        return `${start}-${end}`;
    };

    const btn =
        "w-8 h-8 rounded-lg border border-app-line bg-white text-slate-600 flex items-center justify-center hover:bg-app-bg hover:text-app-ink transition disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white";

    return (
        <div className="flex items-center gap-2 text-[13px]">

            {/* Range dropdown (dynamic) */}
            <select
                value={pageSize}
                onChange={(e) => {
                    setPageSize(Number(e.target.value));
                    setPage(0);
                }}
                aria-label="Rows per page"
                className="h-8 pl-2.5 pr-1 rounded-lg border border-app-line bg-white text-app-ink font-medium tabular-nums outline-none cursor-pointer hover:border-slate-300 focus:ring-4 focus:ring-brand-main/15"
            >
                {[10, 25, 50, 100].map((size) => (
                    <option key={size} value={size}>
                        {getRange(size)}
                    </option>
                ))}
            </select>

            {/* Total */}
            <span className="text-app-muted tabular-nums whitespace-nowrap">
                of {totalItems.toLocaleString()}
            </span>

            {/* Prev */}
            <button
                disabled={page === 0 || loading}
                onClick={() => setPage((p) => p - 1)}
                aria-label="Previous page"
                className={btn}
            >
                <FaChevronLeft size={11} />
            </button>

            {/* Next */}
            <button
                disabled={(totalPages > 0 && page + 1 >= totalPages) || loading}
                onClick={() => setPage((p) => p + 1)}
                aria-label="Next page"
                className={btn}
            >
                <FaChevronRight size={11} />
            </button>
        </div>
    );
}
